/**
 * Date formatting shared by the Candidates tab (Search Detail), the New Import
 * wizard's Thrive path and the People List's Thrive columns. Moved from
 * `routes/client-engagement/searches/CandidatesTable.tsx` (epic
 * 2026-10-15-thrive-search-import, sub-task 03); `SearchDetailPage.tsx` held a
 * byte-identical copy of `formatDate`, now gone.
 */

/** `2026-07-06T12:00:00Z` → `Jul 6, 2026`; anything unparseable → em dash. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return "—";
  return parsed.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/**
 * Whole days between `since` and `now`, floored at zero; `null` when `since`
 * is missing or unparseable. The Candidates tab's PRD example is "a span starting 2026-09-29, now 2026-10-05 → 6 days".
 */
export function daysInStage(since: string | null | undefined, now: Date): number | null {
  if (!since) return null;
  const start = new Date(since);
  if (Number.isNaN(start.getTime())) return null;
  return Math.max(0, Math.floor((now.getTime() - start.getTime()) / 86_400_000));
}

/** `6 days`, `1 day`, `Today`; em dash when the span is unknown. */
export function formatDaysInStage(since: string | null | undefined, now: Date): string {
  const days = daysInStage(since, now);
  if (days === null) return "—";
  if (days === 0) return "Today";
  return days === 1 ? "1 day" : `${days} days`;
}
